"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeBranchName = void 0;
/**
 * Enumeration of the three upgrade branches.
 */
exports.UpgradeBranchName = {
    Defense: 0,
    Range: 1,
    Speed: 2,
};
